// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_header {
  /* width: 1440px; */
  width: 100%;
  height: 90px;
  gap: 0px;
  opacity: 0px;
  position: relative;
}

.header_header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: radial-gradient(104% 47.97% at 50% 52.03%,
      #082b23 0%,
      #10182f 100%);
  /* opacity: 0.95; */
  pointer-events: none;
  height: 90px;
  border-bottom: 1px solid #FFFFFF;
  padding: 0 6rem;
}

.header_company_logo {
  width: 249.62px;
  height: 55px;
  top: 19px;
  left: 150px;
  gap: 0px;
  opacity: 0px;
}

.header_nav {
  gap: 20px;
}

.header_nav_link {
  /* width: 100%; */
  width: auto;
  height: 23px;
  top: 33.5px;
  left: 618px;
  gap: 10px;
  color: #ffffff;
}

.active {
  color: #1b9075;
  /* border-bottom: 3px solid #1b9075; */
}

.text_black {
  color: #000 !important;
}

.header_nav_link .header_link {
  width: auto;
  height: 22px;
  /* top: 33.5px;
    left: 766px; */
  gap: 0px;
  opacity: 0px;
  font-family: Manrope;
  font-size: 16px;
  font-weight: 600;
  line-height: 21.86px;
  text-align: left;
  color: linear-gradient(0deg, #1c1b1d, #1c1b1d),
    linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
}

.header_nav_link .services_link {
  /* width: 66px; */
  width: auto;
  height: 22px;
  /* top: 33.5px;
    left: 766px; */
  gap: 0px;
  opacity: 0px;
  font-family: Manrope;
  font-size: 16px;
  font-weight: 600;
  line-height: 21.86px;
  text-align: left;
  color: linear-gradient(0deg, #1c1b1d, #1c1b1d),
    linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
}

.header_nav_link .about_link {
  /* width: 66px; */
  width: auto;
  height: 22px;
  /* top: 33.5px;
    left: 766px; */
  gap: 0px;
  opacity: 0px;
  font-family: Manrope;
  font-size: 16px;
  font-weight: 600;
  line-height: 21.86px;
  text-align: left;
  color: linear-gradient(0deg, #1c1b1d, #1c1b1d),
    linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
}

.header_nav_link .contact_link {
  /* width: 122.8px; */
  width: auto;
  height: 22px;
  /* top: 33.5px;
    left: 766px; */
  gap: 0px;
  opacity: 0px;
  font-family: Manrope;
  font-size: 16px;
  font-weight: 600;
  line-height: 21.86px;
  text-align: left;
  color: linear-gradient(0deg, #1c1b1d, #1c1b1d),
    linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
}

.header_log_btn {
  width: 153px;
  /* height: 56px; */
  height: auto;
  /* top: 17px;
left: 1136.6px; */
  padding: 20px;
  gap: 10px;
  border-radius: 10px;
  opacity: 0px;
  background: #1b9075;
  animation-timing-function: ease-in;
  animation-duration: 300ms;

  .btn_text {
    /* width: 99px; */
    width: auto;
    height: auto;
    gap: 0px;
    opacity: 0px;
    font-family: Manrope;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.02em;
    text-align: center;
    color: #ffffff;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/home/header.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX;;mBAEiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,WAAW;EACX,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,WAAW;EACX,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;kBACgB;EAChB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB;iEAC+D;AACjE;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ;kBACgB;EAChB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB;iEAC+D;AACjE;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ;kBACgB;EAChB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB;iEAC+D;AACjE;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ;kBACgB;EAChB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB;iEAC+D;AACjE;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ;iBACe;EACf,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,yBAAyB;;EAEzB;IACE,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;EAChB;AACF","sourcesContent":[".header_header {\n  /* width: 1440px; */\n  width: 100%;\n  height: 90px;\n  gap: 0px;\n  opacity: 0px;\n  position: relative;\n}\n\n.header_header::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background: radial-gradient(104% 47.97% at 50% 52.03%,\n      #082b23 0%,\n      #10182f 100%);\n  /* opacity: 0.95; */\n  pointer-events: none;\n  height: 90px;\n  border-bottom: 1px solid #FFFFFF;\n  padding: 0 6rem;\n}\n\n.header_company_logo {\n  width: 249.62px;\n  height: 55px;\n  top: 19px;\n  left: 150px;\n  gap: 0px;\n  opacity: 0px;\n}\n\n.header_nav {\n  gap: 20px;\n}\n\n.header_nav_link {\n  /* width: 100%; */\n  width: auto;\n  height: 23px;\n  top: 33.5px;\n  left: 618px;\n  gap: 10px;\n  color: #ffffff;\n}\n\n.active {\n  color: #1b9075;\n  /* border-bottom: 3px solid #1b9075; */\n}\n\n.text_black {\n  color: #000 !important;\n}\n\n.header_nav_link .header_link {\n  width: auto;\n  height: 22px;\n  /* top: 33.5px;\n    left: 766px; */\n  gap: 0px;\n  opacity: 0px;\n  font-family: Manrope;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 21.86px;\n  text-align: left;\n  color: linear-gradient(0deg, #1c1b1d, #1c1b1d),\n    linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));\n}\n\n.header_nav_link .services_link {\n  /* width: 66px; */\n  width: auto;\n  height: 22px;\n  /* top: 33.5px;\n    left: 766px; */\n  gap: 0px;\n  opacity: 0px;\n  font-family: Manrope;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 21.86px;\n  text-align: left;\n  color: linear-gradient(0deg, #1c1b1d, #1c1b1d),\n    linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));\n}\n\n.header_nav_link .about_link {\n  /* width: 66px; */\n  width: auto;\n  height: 22px;\n  /* top: 33.5px;\n    left: 766px; */\n  gap: 0px;\n  opacity: 0px;\n  font-family: Manrope;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 21.86px;\n  text-align: left;\n  color: linear-gradient(0deg, #1c1b1d, #1c1b1d),\n    linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));\n}\n\n.header_nav_link .contact_link {\n  /* width: 122.8px; */\n  width: auto;\n  height: 22px;\n  /* top: 33.5px;\n    left: 766px; */\n  gap: 0px;\n  opacity: 0px;\n  font-family: Manrope;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 21.86px;\n  text-align: left;\n  color: linear-gradient(0deg, #1c1b1d, #1c1b1d),\n    linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));\n}\n\n.header_log_btn {\n  width: 153px;\n  /* height: 56px; */\n  height: auto;\n  /* top: 17px;\nleft: 1136.6px; */\n  padding: 20px;\n  gap: 10px;\n  border-radius: 10px;\n  opacity: 0px;\n  background: #1b9075;\n  animation-timing-function: ease-in;\n  animation-duration: 300ms;\n\n  .btn_text {\n    /* width: 99px; */\n    width: auto;\n    height: auto;\n    gap: 0px;\n    opacity: 0px;\n    font-family: Manrope;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 20px;\n    letter-spacing: 0.02em;\n    text-align: center;\n    color: #ffffff;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
